import { useQuery } from "@apollo/client";
import { GET_TIME_ZONES } from "../graphql/queries";
import { findTimezoneOption } from './timezoneOptions';

export const useTimeZones = () => {
  const { loading, error, data, refetch } = useQuery(GET_TIME_ZONES);

  return {
    loading,
    error,
    refetch,
    timeZones: data?.getTimeZones || [], // Return an empty array if data is undefined
  };
};
export function GetTimezoneInfo(id) {
  const { timeZones } = useTimeZones();
  return timeZones.find((timezone) => timezone.id === id);
}

export function GetTimezoneInfoByTimezone(timezone) {
  const { timeZones } = useTimeZones();
  return findTimezoneOption(timeZones, timezone);
}
